// Klarna Pay Now: available for transactions between £0 and £4,000
export const KLARNA_MIN_SPEND = 0;
export const KLARNA_MAX_SPEND = 4000;

// Klarna Pay Later: available for transactions between £1 and £600
export const KLARNA_PAY_IN_30_MIN_SPEND = 1;
export const KLARNA_PAY_IN_30_MAX_SPEND = 600;

// Klarna Pay in 3: available for transactions between £1 and £2000
export const KLARNA_PAY_IN_3_MIN_SPEND = 1;
export const KLARNA_PAY_IN_3_MAX_SPEND = 2000;

// PayPal Pay Later: available for transactions between £30 and £2000
export const PAYPAL_PAY_LATER_MIN_SPEND = 30;
export const PAYPAL_PAY_LATER_MAX_SPEND = 2000;
